export enum UserType {
	administrator = 'administrator',
	prosthetist = 'prosthetist',
	production_manager = 'production_manager',
}
